import React, { useState, useEffect } from "react";
import DashboardBarChart from "../../../CommonComponents/Dashboard/DashboardBarChart/DashboardBarChart";
import "./stylesPurchases.css";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import dayjs from "dayjs";

function Purchases({ isApiRunning, dashboardData }) {
  const headers = [
    {
      label: "PURCHASES",
      value: dashboardData.purchases,
      percentage: 10,
    },
    {
      label: "PLAYERS RECEIVED",
      value: dashboardData.players_received,
      percentage: 15,
    },
    {
      label: "PLAYERS USED",
      value: dashboardData.players_used,
      percentage: -10,
    },
  ];

  const [selectedHeader, setSelectedHeader] = useState(headers[0].label);

  const keyFeatures = {
    labels: Array.from({ length: 30 }, (_, i) => {
      const date = dayjs().subtract(29 - i, 'day');
      return date.format('D MMM');
    }),
    datasets: [
      {
        label: "Purchase Match",
        data: Array(30).fill(dashboardData.purchases_by_type.purchase_match / 30),
        backgroundColor: ["#F39C12"],
        borderColor: ["#F39C12"],
        borderWidth: 1,
        borderRadius: 4,
        value: dashboardData.purchases_by_type.purchase_match,
      },
      {
        label: "Free Bets",
        data: Array(30).fill(dashboardData.purchases_by_type.free_bet / 30),
        backgroundColor: ["#9B59B6"],
        borderColor: ["#9B59B6"],
        borderWidth: 1,
        borderRadius: 4,
        value: dashboardData.purchases_by_type.free_bet,
      },
      {
        label: "Free Squares",
        data: Array(30).fill(dashboardData.purchases_by_type.free_squares / 30),
        backgroundColor: ["#E74C3C"],
        borderColor: ["#E74C3C"],
        borderWidth: 1,
        borderRadius: 4,
        value: dashboardData.purchases_by_type.free_squares,
      },
      {
        label: "Profit Boost",
        data: Array(30).fill(dashboardData.purchases_by_type.profit_boost / 30),
        backgroundColor: ["#71BF8A"],
        borderColor: ["#71BF8A"],
        borderWidth: 1,
        borderRadius: 4,
        value: dashboardData.purchases_by_type.profit_boost,
      },
      {
        label: "Insurance Bets",
        data: Array(30).fill(dashboardData.purchases_by_type.insurance_bets / 30),
        backgroundColor: ["#3498DB"],
        borderColor: ["#3498DB"],
        borderWidth: 1,
        borderRadius: 4,
        value: dashboardData.purchases_by_type.insurance_bets,
      },
    ],
  };

  const customOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
        anchor: "end",
        align: "start",
        formatter: (value) => value.toLocaleString(),
        color: "black",
        font: {
          family: "Poppins-regular",
          weight: "bold",
        },
      },
      tooltip: {
        enabled: true,
        mode: "index",
        intersect: false,
        backgroundColor: "#252729",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 15,
        displayColors: true,
        callbacks: {
          label: function (tooltipItem) {
            const label = tooltipItem.dataset.label || "";
            const value = tooltipItem.raw;
            return `${label}: ${value}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        barThickness: 5,
        ticks: {
          color: "#92929E",
          callback: function (value, index, ticks) {
            if (ticks.length > 10) {
              return index % 3 === 0 ? this.getLabelForValue(value) : "";
            }
            return this.getLabelForValue(value);
          },
        },
      },
      y: {
        beginAtZero: true,
        stacked: true,
        ticks: {
          callback: function (value) {
            return value / 1000 + "k";
          },
        },
      },
    },
    interaction: {
      mode: "index",
      intersect: false,
    },
  };

  return (
    <div className="promotions-management-purchases-container">
      {isApiRunning ? (
        <RebetLoader height={"150px"} width={"150px"} />
      ) : (
        <>
          <div className="dashboard-line-chart-header">
            {headers.map((header, index) => (
              <div
                className={`dashboard-line-chart-kpi ${
                  header.label === selectedHeader ? "active" : null
                }`}
                key={index}
                onClick={() => setSelectedHeader(header.label)}
              >
                <div className="dashboard-line-chart-kpi-title">{header.label}</div>
                <div className="dashboard-line-chart-kpi-value">
                  $
                  {Number(header.value).toLocaleString({
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                  <div
                    className={`dashboard-line-chart-kpi-percentage ${
                      header.percentage >= 0 ? "up" : "down"
                    }`}
                  >
                    {header.percentage}%
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="promotions-management-purchases-content">
            <div className="promotions-management-purchases-chart">
              <DashboardBarChart
                data={keyFeatures}
                title=""
                display={true}
                customOptions={customOptions}
                isApiRunning={isApiRunning}
              />
            </div>
            <div className="providers">
              {keyFeatures.datasets.map((provider, index) => (
                <div key={index} className="provider">
                  <div
                    className="provider-color"
                    style={{ backgroundColor: provider.backgroundColor[0] }}
                  ></div>
                  <div className="provider-name">
                    <p className="label">{provider.label}</p>
                    <p className="value">
                      {Number(provider.value).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Purchases;
